var map = {
	"./b2ecebe6-d159-4e61-9656-14530fc11dae-1684906358012.jpg": 407,
	"./d9117308-9a4f-4e5a-a28a-dc40a1e746cd-1684907655368.jpg": 8052,
	"./sample": 8842,
	"./sample.jsx": 8842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2811;